// extracted by mini-css-extract-plugin
export default {"red-color":"wol82aQtVmnGlnrlTU4s"};